import {
  Editor
} from 'slate';

import HelptapEditor from '../../helpers';
import types from '../../elements/types';

function withGallery(editor) {

  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {

    const [node, path] = entry;

    if (node.type === types.GALLERY) {

      const removed = HelptapEditor.gallery.removeEmptyGallery(editor, path);

      if (removed === true) {
        return;
      }

      const handled = HelptapEditor.gallery.normalizeGalleryChildren(editor, path);

      if (handled === true) {
        return;
      }

    }

    if (node.type === types.GALLERY_ITEM) {

      const galleryEntry = Editor.above(editor, {
        at: path,
        match: n => {
          return n.type === types.GALLERY;
        }
      });

      if (galleryEntry) {

        const galleryNode = galleryEntry[0];
        const galleryPath = galleryEntry[1];

        const handled = HelptapEditor.gallery.syncItemStyles(editor, galleryNode, galleryPath, node);

        if (handled === true) {
          return;
        }

      }

    }

    normalizeNode(entry);

  };

  return editor;

}

export default withGallery;
